import { Link } from "react-router-dom";

import Brandmark from "./Brandmark";
import { config } from "../../config";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="oc-footer">
      <div className="oc-footer-brand">
        <Brandmark size={20} ariaLabel={config.brandName} />
        <span className="oc-footer-lockup">
          <span className="oc-footer-wordmark">
            {config.brandName} &copy; {year}
          </span>
          {config.parentName && (
            <span className="oc-footer-parent">
              a{" "}
              {config.parentUrl ? (
                <a
                  href={config.parentUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="oc-footer-parent-link"
                >
                  {config.parentName}
                </a>
              ) : (
                config.parentName
              )}{" "}
              platform
            </span>
          )}
        </span>
      </div>
      <nav className="oc-footer-links" aria-label="Footer">
        {config.contactEmail && (
          <a href={`mailto:${config.contactEmail}`}>Contact</a>
        )}
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </nav>
    </footer>
  );
}
